module.exports = __webpack_public_path__ + "static/04-87870927799e3e2ffe57f4e9810a8843.jpg";